<template>
  <div>
    <b-row>
      <b-col>
        <h4>
          Translations for key: <b-badge class="mr-3">
            {{ row.key }}
          </b-badge>
        </h4>
      </b-col>
    </b-row>

    <b-form @submit.prevent="$emit('submit', row)">
      <b-row v-if="row._showDetails">
        <b-col
          v-for="locale in locales"
          :key="locale.locale"
          md="12">
          <b-form-group
            :label="locale.name">
            <b-form-input
              v-model="row[locale.locale]"
              :value="row[locale.locale]" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            size="sm"
            variant="info"
            type="submit">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>

  import BRow from "bootstrap-vue/src/components/layout/row";
  import BCol from "bootstrap-vue/src/components/layout/col";
  import BBadge from "bootstrap-vue/src/components/badge/badge";
  import BFormGroup from "bootstrap-vue/src/components/form-group/form-group";
  import BButton from "bootstrap-vue/src/components/button/button";
  import BFormInput from "bootstrap-vue/src/components/form-input/form-input";
  import BForm from "bootstrap-vue/src/components/form/form";

  export default {
    name: 'TranslationEdit',
    components: {BForm, BFormInput, BButton, BFormGroup, BBadge, BCol, BRow},

    props: {
      item: {
        type: Object,
        default: () => null
      },
      locales: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      row() {
        return {...this.item};
      }
    }
  }
</script>
